import { render, staticRenderFns } from "./CreatePatient.vue?vue&type=template&id=d59c8838"
import script from "./CreatePatient.vue?vue&type=script&lang=ts"
export * from "./CreatePatient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports